import LoginContainer from "../components/pageComponents/Login/LoginContainer";

const Login=()=>{
    return(<div><LoginContainer /></div>);
}
export default Login;